import ManagementAddTask from 'pages/boarding_management/add_task';
import ChangeModel from 'pages/boarding_management/change_model';
import ChangeTask from 'pages/boarding_management/change_task';
import EmployeeUsers from 'pages/general_settings/employee_users';
import CreateTaskA from 'pages/on_boarding/create_task';
import { WEBCOMPONENTSPROPS } from './projectInterface';
import NESTEDROUTE from './router';

import AddModel from 'pages/boarding_management/add_model';
import AddModelSucceed from 'pages/boarding_management/add_model_succeed';
import AddTaskSucceed from 'pages/boarding_management/add_task_succeed';
import ChangeModelSucceed from 'pages/boarding_management/change_model_succeed';
import ChangeTaskSucceed from 'pages/boarding_management/change_task_succeed';
import AddUser from 'pages/employee_directory/add_a_collaborator';
import Accounts from 'pages/general_settings/accounts';
import UserDefaultSetting from 'pages/general_settings/company/user_default_setting';
import CompanyRecord from 'pages/general_settings/company_record';
import CustomizeDesign from 'pages/general_settings/customize_design';
import EmployeeHistory from 'pages/general_settings/employee_users/EmployeeHistory';
import NewWorkshiftCalendar from 'pages/general_settings/new_workshift_calendar';
import WorkshiftCalendar from 'pages/general_settings/workshift_calendar';
import WorkShiftCalendarDetail from 'pages/general_settings/workshift_calendar/workshift_calendar_detail';
import ChangeRequest from 'pages/my_request/change_request_succeed';
import MyRequestDetail from 'pages/my_request/detail';
import RequestSucceed from 'pages/my_request/request_succeed';
import ModifyActiveTask from 'pages/on_boarding/change_task';
import PersonalData from 'pages/personal_data/[slug]';
import ApprovedSucceed from 'pages/request_approval/approved_succeed';
import RequestApprovalDetail from 'pages/request_approval/detail';
import PublicHolydays from 'pages/staff_leave_&_absences/public_holidays';
import PublicHolidayDetail from 'pages/staff_leave_&_absences/public_holidays/detail';
import NewCalendar from 'pages/staff_leave_&_absences/public_holidays/new_calendar';
import StaffLeaveAndAbsenceTypes from 'pages/staff_leave_&_absences/staff_leave_and _absence_types';
import NewAbsenceTypes from 'pages/staff_leave_&_absences/staff_leave_and _absence_types/create_a_new_staff_leave_types';
import AbsenceTypeDetail from 'pages/staff_leave_&_absences/staff_leave_and _absence_types/detail';
import LeaveProfile from 'pages/staff_leave_&_absences/staff_leave_profile';
import CreateLeaveProfile from 'pages/staff_leave_&_absences/staff_leave_profile/create_leave_profile';
import LeaveProfileDetail from 'pages/staff_leave_&_absences/staff_leave_profile/detail';

export const WEBCOMPONENTS: WEBCOMPONENTSPROPS[] = [
  {
    path: NESTEDROUTE.createTask,
    Component: <CreateTaskA />,
  },
  {
    path: NESTEDROUTE.changeModel,
    Component: <ChangeModel />,
  },
  {
    path: NESTEDROUTE.changeTask,
    Component: <ChangeTask />,
  },
  {
    path: NESTEDROUTE.changeModel_add_task,
    Component: <ManagementAddTask />,
  },
  {
    path: NESTEDROUTE.employee_users,
    Component: <EmployeeUsers />,
  },
  {
    path: NESTEDROUTE.user_default_setting,
    Component: <UserDefaultSetting />,
  },
  {
    path: NESTEDROUTE.personal_data,
    Component: <PersonalData />,
  },
  {
    path: NESTEDROUTE.personal_data_ver2,
    Component: <PersonalData />,
  },
  {
    path: NESTEDROUTE.company_record,
    Component: <CompanyRecord />,
  },
  {
    path: NESTEDROUTE.workshift_calendar,
    Component: <WorkshiftCalendar />,
  },
  {
    path: NESTEDROUTE.new_workshift_calendar,
    Component: <NewWorkshiftCalendar />,
  },
  {
    path: NESTEDROUTE.add_model,
    Component: <AddModel />,
  },
  {
    path: NESTEDROUTE.staff_absence_holiday,
    Component: <PublicHolydays />,
  },
  {
    path: NESTEDROUTE.create_new_calendar,
    Component: <NewCalendar />,
  },
  {
    path: NESTEDROUTE.staff_leave_and_absence_types,
    Component: <StaffLeaveAndAbsenceTypes />,
  },
  {
    path: NESTEDROUTE.new_absence_types,
    Component: <NewAbsenceTypes />,
  },
  {
    path: NESTEDROUTE.staff_leave_profile,
    Component: <LeaveProfile />,
  },
  {
    path: NESTEDROUTE.create_profile,
    Component: <CreateLeaveProfile />,
  },
  {
    path: NESTEDROUTE.add_collaborator,
    Component: <AddUser />,
  },
  {
    path: NESTEDROUTE.customize_design,
    Component: <CustomizeDesign />,
  },
  {
    path: `/general_settings/workshift_calendar/detail`,
    Component: <WorkShiftCalendarDetail />,
  },
  {
    path: NESTEDROUTE.modify_active_task,
    Component: <ModifyActiveTask />,
  },
  {
    path: NESTEDROUTE.add_task_succeed,
    Component: <AddTaskSucceed />,
  },
  {
    path: NESTEDROUTE.change_model_succeed,
    Component: <ChangeModelSucceed />,
  },
  {
    path: NESTEDROUTE.add_model_succeed,
    Component: <AddModelSucceed />,
  },
  {
    path: NESTEDROUTE.change_task_succeed,
    Component: <ChangeTaskSucceed />,
  },
  {
    path: NESTEDROUTE.accounts,
    Component: <Accounts />,
  },
  {
    path: NESTEDROUTE.staff_leave_types_detail,
    Component: <AbsenceTypeDetail />,
  },
  {
    path: NESTEDROUTE.staff_leave_profile_detail,
    Component: <LeaveProfileDetail />,
  },
  {
    path: NESTEDROUTE.staff_leave_holiday_detail,
    Component: <PublicHolidayDetail />,
  },
  {
    path: NESTEDROUTE.request_approval_detail,
    Component: <RequestApprovalDetail />,
  },
  {
    path: NESTEDROUTE.my_request_detail,
    Component: <MyRequestDetail />,
  },
  {
    path: NESTEDROUTE.approved_request,
    Component: <ApprovedSucceed />,
  },
  {
    path: NESTEDROUTE.created_request,
    Component: <RequestSucceed />,
  },
  {
    path: NESTEDROUTE.change_request,
    Component: <ChangeRequest />,
  },
  {
    path: NESTEDROUTE.employee_history,
    Component: <EmployeeHistory />,
  },
];
